module.exports = __webpack_public_path__ + "images/drawings/moon/first-quarter.18a318778293f167e70a1e9d7dd7fc31.png";